module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/community-f5552c1276dbf5d3100c4420b5d4defd.png";